import {
    LOOKUP_GET_LIST_CUSTOMER
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    lookup_customerList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOOKUP_GET_LIST_CUSTOMER: {
            return {
                ...state,
                lookup_customerList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        default: return { ...state };
    }
}
